import React from 'react';
import Select from 'react-select';
import IndefiniteProgressbar from "../IndefiniteProgressbar.mjs";
import {ts2m, ts2d, ts2y, ts2dmmm, ts2yyyy, ts2dmy} from "../../Services/Conversions.mjs";

class SelectSlot extends React.Component {
	constructor(opts) {
		super(opts);
		this.state = { slots: false, of: opts.of };
		this.loadSlot.bind(this);
		this.slot2options.bind(this);
		this.onchange.bind(this);
		this.uid = "SelectSlot-"+window.glob.generateUid();
	};
	componentDidMount() {
		if ( this.props.globPrefix && this.props.deps && this.props.deps.ente) {
			window.glob.register(this.props.globPrefix+'changed.'+this.props.deps.ente,(e)=> {
				if ( e ) {
					this.setState({ ente: e, slots: false });
				} else {
					this.setState({ ente: false, slots: false });
				}
			}, this.uid );
		}
	};
	componentWillUnmount() {
		if ( this.props.globPrefix && this.props.deps && this.props.deps.of) {
			window.glob.unregister(this.props.globPrefix+'changed.'+this.props.deps.ente,this.uid );
		}
	};
	loadSlot() {
		window.glob.api( 'lsSlot', this.state.ente).then( (e)=>{
			this.slot2options(e);
		});
	};
	slot2options(el) {
		if ( ! el.length ) {
			this.setState({ slots: [false] });
			return;
		}
		const intlabel = d => {
			if (ts2y(d.dtstart) === ts2y(d.dtend)) {
				if (ts2m(d.dtstart) === ts2m(d.dtend)) {
					return `dal ${ts2d(d.dtstart)} al ${ts2dmmm(d.dtend)} ${ts2yyyy(d.dtend)}`;
				}
				return `dal ${ts2dmmm(d.dtstart)} al ${ts2dmmm(d.dtend)} ${ts2yyyy(d.dtend)}`;
			}
			return `dal ${ts2dmy(d.dtstart)} al ${ts2dmy(d.dtend)}`;
		};
		let e = el
			.sort( (a,b)=> (a.dtstart > b.dtstart ? 1 : -1))
			.map( i => ({
			label : `${i.ldesc}, ${intlabel(i)}`,
			value: JSON.stringify(i)
		}));
		this.setState({ slots: e });
	}
	onchange(v) {
		if ( this.props.globPrefix && this.props.name ) {
			window.glob.trigger(
				this.props.globPrefix+'changed',
				{ name: this.props.name, value: (v && typeof v === "object" ? JSON.parse(v.value) : undefined) }
			);
		}
	}
	render() {
		if ( ! this.state.ente ) {
			this.slots = false;
			return <p className={"comment"}>↳ Scegli prima il Corso di Laurea.</p>;
		}
		if ( ! this.state.slots ) {
			setTimeout( ()=>{ this.loadSlot() }, 100);
			return <p className={"comment"}><IndefiniteProgressbar /></p>;
		}
		if ( ! this.state.slots[0] ) {
				return <p className={"error"}>Nessuna sessione disponibile — Contattare la segreteria.</p>;
		}
		return (
			<div>
				<Select
					id={this.uid}
					options={this.state.slots}
					autoFocus={true}
					onChange={ (v)=> { this.onchange(v) }}
				/>
			</div>
		);
	}
}

export default SelectSlot;